var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container mt-5" }, [
    _c(
      "div",
      [
        _c("Breadcrumb", { attrs: { blogId: _vm.blogId } }),
        _vm._v(" "),
        _vm.blog
          ? _c("div", [
              _c("h1", [_vm._v(_vm._s(_vm.blog.post_title))]),
              _vm._v(" "),
              _c("img", {
                staticClass: "img-blog-title",
                attrs: {
                  src: _vm.blog.post_image_url,
                  alt: _vm.blog.post_title
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-lg-flex justify-content-between align-items-baseline detail"
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "created-by" }, [
                      _vm._v("By BeNeat"),
                      _c("span", { staticClass: "mx-5" }, [
                        _c("i", { staticClass: "time" }),
                        _vm._v(
                          _vm._s(
                            _vm._f("prettyOnlyDateBE")(_vm.blog.updated_at)
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("\n                  แชร์:\n                  "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://www.facebook.com/sharer/sharer.php?u=" +
                            _vm.url,
                          target: "_blank"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "img-icon-share",
                          attrs: { src: "/static/img/socialMedie/facebook.png" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://x.com/intent/post?text=+" + _vm.url,
                          target: "_blank"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "img-icon-share",
                          attrs: { src: "/static/img/socialMedie/x.png" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://social-plugins.line.me/lineit/share?url=" +
                            _vm.url +
                            "&text=text",
                          target: "_blank"
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "img-icon-share",
                          attrs: { src: "/static/img/socialMedie/line.png" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        ref: "mylink",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.copyURL()
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "img-icon-share",
                          attrs: { src: "/static/img/socialMedie/chain.png" }
                        })
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "mt-3",
                attrs: { id: "htmlContainer" },
                domProps: { innerHTML: _vm._s(_vm.blog.post_content) }
              })
            ])
          : _c("div", [
              _c("h3", { staticClass: "text-center" }, [_vm._v("ไม่พบข้อมูล")])
            ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.blog
      ? _c("p", [_vm._v("💙ビニート💙 𝗕𝗲𝗡𝗲𝗮𝘁 บริการสุดหัวใจ")])
      : _vm._e(),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("section", [
      _vm._m(0),
      _vm._v(" "),
      _vm.$mq.phone
        ? _c(
            "div",
            { staticStyle: { "margin-top": "32px", "margin-bottom": "124px" } },
            [
              _c("div", {}, [
                _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "owl-carousel blog-carousel owl-theme homepage"
                    },
                    _vm._l(_vm.blogs, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "item" },
                        [_c("cardBlog", { attrs: { item: item } })],
                        1
                      )
                    }),
                    0
                  )
                ])
              ])
            ]
          )
        : _c(
            "div",
            { staticStyle: { "margin-bottom": "124px" } },
            [
              _c("Blogs", {
                attrs: {
                  queryDataPage: 0,
                  queryDataLimit: 7,
                  showInPageConent: true,
                  blogId: _vm.blogId
                }
              })
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "latest-articles" }, [
      _c("strong", [_vm._v("บทความล่าสุด")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7126cbfb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7126cbfb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blogs/Content.vue
// module id = 2476
// module chunks = 0